import { NavbarComponent } from './navbar/navbar.component';

import { AuthService } from './auth/auth.service';

import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  NavigationEnd,
  NavigationError,
  Router,
  RouterModule,
} from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { faLayerGroup, fas } from '@fortawesome/pro-solid-svg-icons';

import { environment } from '../environments/environment';

import rg4js from 'raygun4js';
import { faRoad } from 'src/constants';

export const MODULES = [CommonModule, RouterModule];
export const COMPONENTS = [NavbarComponent];
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [...MODULES, ...COMPONENTS],
})
export class AppComponent implements OnInit {
  public translate = inject(TranslateService);
  public auth = inject(AuthService);
  private router = inject(Router);
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  private cd = inject(ChangeDetectorRef);
  public library = inject(FaIconLibrary);

  title = 'Einsatzwetter-FE-V3';

  constructor() {
    this.addCustomIcons();
    this.auth.setLanguage();
    this.library.addIconPacks(far, fas, fad, fal);
    this.library.addIcons(faRoad, faLayerGroup);
    this.auth.initLocalStorageValues();
  }

  ngOnInit(): void {
    this.auth.initAuth().then(() => {
      this.cd.detectChanges();

      if (environment.production) {
        this.router.events.subscribe(
          event => {
            if (this.auth.authenticated()) {
              const raygunUserData = localStorage.getItem('raygun_userdata');
              if (raygunUserData) {
                rg4js('setUser', JSON.parse(raygunUserData));
              }
              // Track page views when the NavigationEnd event occurs
              if (event instanceof NavigationEnd) {
                rg4js('trackEvent', {
                  type: 'pageView',
                  path: event.url,
                });
              }

              // Track navigation errors when the NavigationError event occurs
              if (event instanceof NavigationError) {
                // Track navigation error
                rg4js('send', {
                  error: event.error,
                });
              }
            }
          },
          error => console.log('Error AppComponent ngOninit', error)
        );
      }
    });
  }

  addCustomIcons(): void {
    for (let n = 0; n < 10; n++) {
      this.matIconRegistry.addSvgIcon(
        'ne_' + n,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          '../assets/symbols/N_TotalCloudCover/WeatherSymbol_WMO_TotalCloudCover_N_' +
            n +
            '.svg'
        )
      );
    }
  }
}
